import { render, staticRenderFns } from "./report-card.vue?vue&type=template&id=8e90ed44&scoped=true&lang=pug&"
import script from "./report-card.vue?vue&type=script&lang=js&"
export * from "./report-card.vue?vue&type=script&lang=js&"
import style0 from "./report-card.vue?vue&type=style&index=0&id=8e90ed44&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e90ed44",
  null
  
)

export default component.exports